import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, unref as _unref, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9deee534")

_pushScopeId("data-v-9deee534")
const _hoisted_1 = { class: "pricing-container" }
const _hoisted_2 = { class: "current-plan" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "plan-info" }, [
  /*#__PURE__*/_createVNode("p", { class: "plan-label" }, "Your current plan"),
  /*#__PURE__*/_createVNode("h3", { class: "plan-title" }, "Temporary Account"),
  /*#__PURE__*/_createVNode("p", { class: "plan-subtitle" }, "Limitation with access")
], -1)
const _hoisted_4 = { class: "plan-price" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = {
  key: 0,
  class: "selected-plan-summary"
}
const _hoisted_7 = { class: "summary-content" }
const _hoisted_8 = { class: "plan-cards" }
const _hoisted_9 = {
  key: 0,
  class: "recommendation-badge"
}
const _hoisted_10 = { class: "plan-name" }
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", { class: "divider" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "color-border" }, null, -1)
const _hoisted_13 = { class: "modal-wrap default-modal" }
const _hoisted_14 = {
  key: 0,
  class: "modal"
}
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", null, "Plan Change Confirmed", -1)
_popScopeId()

import { ref, reactive, computed, onMounted } from 'vue';
import { ethitransService } from "@/services/EthitransService";


// State

export default _defineComponent({
  expose: [],
  setup(__props) {

const isAnnual = ref(true);
const selectedPlan = ref(null);
const showConfirmationModal = ref(false);

// Plan data
const plans = {
  basic: {
    id: 'basic',
    name: 'Free',
    monthlyPrice: '0',
    monthlyOriginalPrice: '0',
    monthlySavings: '0',
    monthlyPriceAfter: '0',
    annualPrice: '0',
    annualOriginalPrice: '0',
    annualSavings: '0',
    annualPriceAfter: '0',
    features: ['5 Projects, 5 Channels, 5 Members']
  },
  premium: {
    id: 'premium',
    name: 'Silver',
    monthlyPrice: '9.99',
    monthlyOriginalPrice: '12.99',
    monthlySavings: '3',
    monthlyPriceAfter: '12.99',
    annualPrice: '89.99',
    annualOriginalPrice: '119.88',
    annualSavings: '29',
    annualPriceAfter: '99.99',
    features: [
      '500GB  of storage,',
      '100 Projects, 100, Channels, 100 Members'
    ]
  },
  aiPremium: {
    id: 'aiPremium',
    name: 'Platinum',
    monthlyPrice: '19.99',
    monthlyOriginalPrice: '19.99',
    monthlySavings: '0',
    monthlyPriceAfter: '19.99',
    features: [
      '1TB of storage',
      'Unlimited Projects',
      'Unlimited Channels',
      'Unlimited Members',
      'Unlimited Smart Contracts',
      'and More'
    ]
  }
};

// Current plan (free tier)
const state = reactive({
  data: {
    registrationDetails: {
      packages: [] as any,
    }
  },
  ui: {

  }
});

// Current plan (free tier)
const currentPlan = {
  id: 'free',
  name: 'Free',
  storage: '100 MB',
  description: 'included limited access',
  price: '0'
};

// Computed properties
const nextBillingDate = computed(() => {
  const date = new Date();
  date.setMonth(date.getMonth() + (isAnnual.value ? 12 : 1));
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
});

// Methods
function toggleBillingCycle(annual) {
  isAnnual.value = annual;

  // If AI Premium is selected and switching to annual, deselect it
  if (selectedPlan.value && selectedPlan.value.id === 'aiPremium' && annual) {
    selectedPlan.value = null;
  }
}

function selectPlan(plan: any) {
  // If selecting AI Premium but on annual billing, show message
  if (plan.id === 'aiPremium' && isAnnual.value) {
    return;
  }

  selectedPlan.value = plan;
}

function switchToMonthlyForAI() {
  isAnnual.value = false;
  selectPlan(plans.aiPremium);
}
function getRegistrationsDetailList() {
  const data: any = {}
  console.log("getprojectList WOWO:>>>");
  ethitransService
    .registrationsDetailList(data)
    .then((res: any) => {
      console.log("getRegistrationsDetailList Check:>>> ", res.data.data);
      state.data.registrationDetails = res.data.data;
      if (res.data.data.refferal != undefined) {
        state.data.selectedSubscriptionId = res.data.data.refferal.package_id;
      }
    })
    .catch((error: any) => {
      console.log(error);
    })
    .finally(() => {
      // state.ui.postLoading.getprojectList = false;
    });
}

function confirmPlanSelection() {
  // In a real app, this would call an API to update the subscription
  showConfirmationModal.value = true;
}

function cancelSelection() {
  selectedPlan.value = null;
}

function closeConfirmationModal() {

  // Update current plan to selected plan
  currentPlan.id = selectedPlan.value.id;
  currentPlan.name = selectedPlan.value.name;
  // currentPlan.storage = selectedPlan.value.id === 'basic' ? '100 GB' : '2 TB';
  // currentPlan.description = `${isAnnual.value ? 'Annual' : 'Monthly'} plan`;
  currentPlan.price = isAnnual.value ?
    selectedPlan.value.annualPrice :
    selectedPlan.value.monthlyPrice;

  // API calls
  ethitransService
    .changePackageByUser(currentPlan.id)
    .then((res: any) => {

      showConfirmationModal.value = false;
      selectedPlan.value = null;



      // state.data.successFulMessage = "Channel Edited Successfully.";
      // state.roleList = filteredRoles ? filteredRoles : [];
    })
    .catch((error: any) => {
      // console.log(error);
      // common
      //   .sdCatchErr(error, state.ui.errors.errorList.saveEditChannel)
      //   .then((res: any) => {
      //     state.ui.errors.hasError = true;
      //     for (const [key, value] of Object.entries(res)) {
      //       if (Array.isArray(value)) {
      //         state.ui.errors.errorList.saveEditChannel.push(value[0]);
      //       }
      //     }
      //   });
    })
}
onMounted(() => {
  getRegistrationsDetailList();
});

return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("h3", _hoisted_5, "$" + _toDisplayString(currentPlan.price), 1)
      ])
    ]),
    (selectedPlan.value && selectedPlan.value.id !== currentPlan.id)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("h3", null, "You've selected: " + _toDisplayString(selectedPlan.value.name), 1),
            _createVNode("p", null, _toDisplayString(isAnnual.value ? 'Annual' : 'Monthly') + " billing at $" + _toDisplayString(selectedPlan.value.price) + " " + _toDisplayString(isAnnual.value ? '/year' : '/month'), 1),
            _createVNode("div", { class: "summary-actions" }, [
              _createVNode("button", {
                class: "confirm-btn",
                onClick: confirmPlanSelection
              }, "Confirm Selection"),
              _createVNode("button", {
                class: "cancel-btn",
                onClick: cancelSelection
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(state.data.registrationDetails.packages, (plan, planIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: ["plan-card", {
          recommended: true,
          selected: selectedPlan.value && selectedPlan.value.name === plan.name
        }],
          key: planIndex,
          onClick: ($event: any) => (selectPlan(plan))
        }, [
          true
            ? (_openBlock(), _createBlock("div", _hoisted_9, "Recommended"))
            : _createCommentVNode("", true),
          _createVNode("h3", _hoisted_10, _toDisplayString(plan.name), 1),
          _createVNode("button", {
            class: "discount-btn primary",
            onClick: _withModifiers(($event: any) => (selectPlan(plan)), ["stop"])
          }, _toDisplayString(selectedPlan.value && selectedPlan.value.name ? 'Selected' : 'Select'), 9, ["onClick"]),
          _hoisted_11,
          _hoisted_12
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_13, [
      (showConfirmationModal.value)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("p", null, "You would like to select the " + _toDisplayString(selectedPlan.value.name) + " plan.", 1),
              _createVNode("p", null, "Your next billing date will be " + _toDisplayString(_unref(nextBillingDate)) + ".", 1),
              _createVNode("button", {
                class: "confirm-btn",
                onClick: closeConfirmationModal
              }, "Got it")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})
}

})